import React from "react";
import CallbackIcon from "@mui/icons-material/PhoneCallback";
import CallIcon from "@mui/icons-material/Call";
import NoteIcon from "@mui/icons-material/Chat";
import { EmailOutlined } from "@mui/icons-material";

const Config = {
  "CALLBACK":{
    title: "Callback Requested",
    icon: <CallbackIcon/>
  },
  "CALL":{
    title: "Call",
    icon: <CallIcon/>
  },
  "EMAIL":{
    title: "Email",
    icon: <EmailOutlined/>
  },
  "NOTE":{
    title: "Note",
    icon: <NoteIcon/>
  }
}

export default Config;